import { Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Filter } from "iconsax-react";
import { memo } from "react";

import type { FilterButtonProps } from "./FilterButton.types";
import * as styles from "./FilterButton.styles";

export type { FilterButtonProps } from "./FilterButton.types";

export const FilterButton = memo(function FilterButton({
  children,
  withIcon = false,
  ...buttonProps
}: FilterButtonProps) {
  const theme = useTheme();

  return (
    <Button
      variant="outlined"
      sx={styles.root}
      startIcon={
        withIcon ? (
          <Filter size={20} variant="Linear" color={theme.palette.text.secondary} />
        ) : undefined
      }
      {...buttonProps}
    >
      {children}
    </Button>
  );
});
